
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18.352 1.326A1.242 1.242 0 0016.67.774l-.02.01-5.19 2.811a2.564 2.564 0 01.568 3.544c-.158.222-.35.416-.568.576l5.19 2.81a1.24 1.24 0 001.702-.541 9.67 9.67 0 000-8.658zm-16.704 0A1.242 1.242 0 013.35.784l5.19 2.811a2.564 2.564 0 00-.568 3.544c.157.222.35.416.568.576l-5.19 2.81a1.24 1.24 0 01-1.692-.521l-.01-.02a9.67 9.67 0 010-8.658z"}}),_c('path',{attrs:{"d":"M10 3.116c1.38 0 2.5 1.137 2.5 2.539 0 1.402-1.12 2.538-2.5 2.538S7.5 7.057 7.5 5.655 8.62 3.116 10 3.116zm2.5 2.539h1.875m-8.75 0H7.5"}})])])
          )
        }
      }
    